import React, { useState } from "react";
import ListCategoryUserSitePublisher from "./ListCategoryUserSitePublisher";
import helperNumber from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import { Link } from "react-router-dom";

function GroupPublisher() {
  const [showSelectTagMannerAddGroup, setShowSelectTagMannerAddGroup] =
    useState(false);
  const [linkPageAddGroup, setLinkPageAddGroup] = useState(false);

  const generateListCategoryUserSitePublisher = () => {
    return ListCategoryUserSitePublisher.map((group, index) => {
      return (
        <tr key={index}>
          <td>{helperNumber.toPersianNum(index + 1)}</td>
          <td>{helperNumber.toPersianNum(group.id)}</td>
          <td>{group.name}</td>
          <td className="number-finance">
            <span>
              {helperNumber.toPersianNum(
                helpersTime.convertGregorianToJalali(group.start_date)
              )}
            </span>
            <span className="pl-2">۰۰:۰۰</span>
          </td>
          <td className="number-finance">
            <span>
              {helperNumber.toPersianNum(
                helpersTime.convertGregorianToJalali(group.end_date)
              )}
            </span>
            <span className="pl-2">۲۳:۵۹</span>
          </td>
          <td className="number-finance">
            {helperNumber.toPersianNum(
              group.created_at.split(" ")[1] +
                " " +
                helpersTime.convertGregorianToJalali(
                  group.created_at.split(" ")[0]
                )
            )}
          </td>
          <td>
            <div>
              <span className="pl-2">
                <Link
                  to={`/publishers/edit-group/${group.id}`}
                  className="btn btn-success  "
                >
                  <i className="fa fa-edit"></i>
                </Link>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  const showButtonGroup = () => {
    return (
      <div className="d-flex flex-column flex-lg-row ">
        <div className="pb-2 pb-lg-2">
          <div
            className="btn btn-success"
            onClick={() => {
              setShowSelectTagMannerAddGroup(true);
            }}
          >
            <span className="pl-2">
              <i className="fa fa-plus"></i>
            </span>
            <span>
              <span>اضافه کردن گروه جدید</span>
            </span>
          </div>
        </div>
        {showSelectTagMannerAddGroup && (
          <>
            <div className="pb-2 pb-lg-0 pr-lg-2">
              <select
                className="form-control"
                onChange={(e) => {
                  const link = e.target.value;
                  if (!link) {
                    setLinkPageAddGroup(false);
                    return;
                  }
                  setLinkPageAddGroup(link);
                }}
              >
                <option value="">روش ساخت گروه را انتخاب کنید</option>
                <option value="/publishers/add-group/banner">دستی</option>
                <option value="/publishers/add-group-automate/banner">
                  خودکار
                </option>
              </select>
            </div>

            {linkPageAddGroup && (
              <div className="pb-2 pr-lg-2">
                <Link to={linkPageAddGroup} className="btn btn-success">
                  افزودن
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  return (
    <>
      <div
        className="tab-pane fade border border-3 p-2 rounded"
        id="group-publisher"
        role="tabpanel"
        aria-labelledby="group-publisher-tab"
      >
        {showButtonGroup()}
        <div class="table-responsive pt-2">
          <table class="table table-hilite tbl-td-white-space mb-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره گروه</td>
                <td>نام گروه</td>
                <td>تاریخ شروع</td>
                <td>تاریخ پایان</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>{generateListCategoryUserSitePublisher()}</tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default GroupPublisher;
